import _ from 'underscore';

export default class ProductConstants {
  products: any;
  
  constructor() {
    this.products = this.initialProducts();

    this.products['com.atlassian.hipchat.data-center'] = {
      'productLongDescription': {
        'default': 'Hipchat is a hosted private chat service for your company and team. Share ideas and files in persistent group chat rooms, video chats, and more. Get your team off AIM, Google Talk, and Skype – Hipchat is built for business.'
      },
      'productTagLine': {
        'default': 'Chat and share'
      },
      'images': {
        'xxx' : '/sc-shared/img/productLogos/Hipchat-blue.svg',
        'xx' : '/sc-shared/img/productLogos/Hipchat-blue.svg'
      },
      'onDemand': {
        'available': true,
        'url': 'https://www.hipchat.com/sign_up?utm_source=atlassian&utm_medium=wac-order-form&utm_campaign=hipchat-launch'
      },
      'url': 'product/com.atlassian.hipchat.data-center',
        'productName': 'Hipchat',
        'productGroup': 'com.atlassian.hipchat',
        'editionName': 'dataCenter'
    };


    this.products['crowd.data-center'] = {
      'productLongDescription': {
        'default': 'Identity management for your users, web apps, and directory servers.'
      },
      'productTagLine': {
        'default': 'Identity management'
      },
      'images': {
        'xxx': '/sc-shared/img/productLogos/Crowd-blue.svg',
        'xx': '/sc-shared/img/productLogos/Crowd-blue.svg'
      },
      'moreLink': 'https://www.atlassian.com/software/crowd/overview',
      'onDemand': {
        'available': false,
        'key': null
      },
      'url': 'product/crowd',
      'productName': 'Crowd Data Center',
      'productGroup': 'crowd',
      'editionName': 'dataCenter'
    };

    this.products['premier-support'] = {
      'productLongDescription': {
        'default': 'Our highest level of support, including coverage for all of your Atlassian applications and 24/7 access to a team of dedicated senior support engineers.'
      },
      'productTagLine': {
        'default': 'Account-level coverage'
      },
      'support': {
        'description': 'Premier Support connects our top tier engineers with the customer. In order to ensure the best outcomes, we limit the number of individuals within an account to <strong>three named contacts</strong>.'
      },
      'url': 'product/premier-support',
      'productName': 'Premier Support',
      'productGroup': 'premierSupport',
      'editionName': 'support'
    };

    var prioritySupport = {
      'productLongDescription': {
        'default': 'Ensure your mission-critical Atlassian Server and Data Center applications scale successfully.'
      },
      'productTagLine': {
        'default': 'Flexible coverage'
      },
      'support': {
        'description': 'Priority Support for Atlassian Server ensures your mission-critical Atlassian Server and Data Center applications scale successfully.'
      },
      'productName': 'Priority Support',
      'productGroup': 'prioritySupport'
    };

    this.products['priority-support.server'] = _.defaults({
      'url': 'product/priority-support.server',
      'editionName': 'server'
    }, prioritySupport);

    this.products['priority-support.data-center'] = _.defaults({
      'url': 'product/priority-support.data-center',
      'editionName': 'dataCenter'
    }, prioritySupport);
  }

  initialProducts() {
    return {
      'jira': {
          'productLongDescription': {
            'default': 'Enable development and IT teams to capture issues, plan work, and resolve requests. Spend less time managing work and more time building great software.'
          },
          'productTagLine': {
              'default': 'Plan, track, work'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira-blue.svg'
          },
          'recommendedProducts': ['com.pyxis.greenhopper.jira', 'com.atlassian.servicedesk', 'confluence', 'stash', 'com.radiantminds.roadmaps-jira'],
          'moreLink': 'https://www.atlassian.com/software/jira',
          'onDemand': {
              'available': true,
              'key': 'jira.ondemand'
          },
          'url': 'product/jira',
          store: false,
          'productName': 'Jira'
      },
      'jira-data-center': {
          'productLongDescription': {
            'default': 'Enable development and IT teams to capture issues, plan work, and resolve requests. Spend less time managing work and more time building great software.'
          },
          'productTagLine': {
              'default': 'Plan, track, work'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira-blue.svg'
          },
          'moreLink': 'https://www.atlassian.com/software/jira',
          'onDemand': null,
          'productName': 'Jira Data Center'
      },
      'com.pyxis.greenhopper.jira': {
          'productLongDescription': {
            'default': 'Agile project management for scrum or kanban teams.'
          },
          'productTagLine': {
              'default': 'Agile project management'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/jiraagile_blue_xxxsmall.png',
              'xx': '/sc-shared/img/productLogos/jiraagile_blue_xxsmall.png'
          },
          'recommendedProducts': [],
          'moreLink': 'https://www.atlassian.com/software/jira-agile/overview',
          'onDemand': {
              'available': true,
              'key': 'greenhopper.jira.ondemand'
          },
          'url': 'addon/com.pyxis.greenhopper.jira',
          store: false,
          'productName': 'Jira Agile'
      },
      'com.atlassian.servicedesk': {
          'productLongDescription': {
            'default': 'Deliver an effortless service experience with powerful ticket management, an intuitive self-service portal, advanced SLAs and real-time reporting.'
          },
          'productTagLine': {
              'default': 'Service and support',
              'jira': ' '
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg'
          },
          'recommendedProducts': [],
          'moreLink': 'https://www.atlassian.com/software/jira/service-desk',
          'onDemand': {
              'available': true,
              'key': 'com.atlassian.servicedesk.ondemand'
          },
          'url': 'software/com.atlassian.servicedesk',
          store: false,
          'productName': 'Jira Service Desk'
      },
      'com.atlassian.bonfire.plugin': {
          'productLongDescription': {
            'default': 'Rapid bug reporting for exploratory and session-based testing.'
          },
          'productTagLine': {
              'default': 'Exploratory testing'
          },
          'images': {
              'xxx': null,
              'xx': null
          },
          'recommendedProducts': [],
          'moreLink': 'https://www.atlassian.com/software/jira-capture/overview',
          'onDemand': {
              'available': true,
              'key': 'bonfire.jira.ondemand'
          },
          'url': 'addon/com.atlassian.bonfire.plugin',
          'productName': 'Capture for Jira',
          addon: true,
          'productGroup': 'com.atlassian.bonfire.plugin',
          'editionName': 'server'
      },
      'com.radiantminds.roadmaps-jira': {
          'productLongDescription': {
              'default': 'Know when you can deliver, react to change and keep everyone on the same page.'
          },
          'productTagLine': {
              'default': 'See the big picture: Plan across multiple projects and teams'
          },
          'images': {
              'xxx': null,
              'xx': null
          },
          'recommendedProducts': [],
          'moreLink': 'https://marketplace.atlassian.com/plugins/com.radiantminds.roadmaps-jira',
          'onDemand': {
              'available': true,
              'key': 'com.radiantminds.roadmaps-jira.ondemand'
          },
          'url': 'addon/com.radiantminds.roadmaps-jira',
          'productName': 'Portfolio for Jira',
          addon: true,
          'productGroup': 'com.radiantminds.roadmaps-jira',
          'editionName': 'server'
      },
      'confluence': {
          'productLongDescription': {
            'default': 'Give your team one place to share, find, and collaborate on information they need to get work done.'
          },
          'productTagLine': {
              'default': 'Create & collaborate'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Confluence-blue.svg',
              'xx': '/sc-shared/img/productLogos/Confluence-blue.svg'
          },
          'recommendedProducts': [ 'com.atlassian.confluence.plugins.confluence-questions', 'com.atlassian.confluence.extra.team-calendars', 'jira', 'jira-software' ],
          'moreLink': 'https://www.atlassian.com/software/confluence',
          'onDemand': {
              'available': true,
              'key': 'confluence.ondemand'
          },
          'url': 'product/confluence',
          'productName': 'Confluence',
          'productGroup': 'confluence',
          'editionName': 'server'
      },
      'confluence-data-center': {
          'productLongDescription': {
            'default': 'Give your team one place to share, find, and collaborate on information they need to get work done.'
          },
          'productTagLine': {
              'default': 'Create & collaborate'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Confluence-blue.svg',
              'xx': '/sc-shared/img/productLogos/Confluence-blue.svg'
          },
          'moreLink': 'https://www.atlassian.com/software/confluence',
          'onDemand': null,
          'productName': 'Confluence Data Center',
          'productGroup': 'confluence',
          'editionName': 'dataCenter'
      },
      'com.atlassian.confluence.plugins.confluence-questions': {
          'productLongDescription': {
            'default': 'Capture, learn from, and retain the collective knowledge of your organization as it grows.'
          },
          'productTagLine': {
              'default': 'Share knowledge'
          },
          'images': {
              'xxx': null,
              'xx': null
          },
          'recommendedProducts': [],
          'moreLink': 'https://marketplace.atlassian.com/plugins/com.atlassian.confluence.plugins.confluence-questions',
          'onDemand': {
              'available': true,
              'key': 'com.atlassian.confluence.plugins.confluence-questions.ondemand'
          },
          'url': 'addon/com.atlassian.confluence.plugins.confluence-questions',
          'productName': 'Questions for Confluence',
          addon: true,
          'productGroup': 'com.atlassian.confluence.plugins.confluence-questions',
          'editionName': 'server'
      },
      'com.atlassian.confluence.extra.team-calendars': {
          'productLongDescription': {
            'default': 'Your team\'s single source of truth for managing team leave, tracking Jira projects, and planning events. Confluence Team Calendars connects Confluence and Jira like never before.'
          },
          'productTagLine': {
              'default': 'Shared calendars',
              'confluence': ' '
          },
          'images': {
              'xxx': null,
              'xx': null,
              'xxx_short': null,
              'xx_short': null
          },
          'recommendedProducts': [],
          'moreLink': 'https://www.atlassian.com/software/confluence/team-calendars',
          'onDemand': {
              'available': true,
              'key': 'team.calendars.confluence.ondemand'
          },
          'url': 'addon/com.atlassian.confluence.extra.team-calendars',
          'productName': 'Team Calendars for Confluence',
          addon: true,
          'productGroup': 'com.atlassian.confluence.extra.team-calendars',
          'editionName': 'server'
      },
      'stash': {
          'productLongDescription': {
              'default': 'Collaborate on code with inline comments and pull requests. Manage and share your Git repositories. Build and ship as a team.'
          },
          'productTagLine': {
              'default': 'Git-based code collaboration and management'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Bitbucket-blue.svg',
              'xx':  '/sc-shared/img/productLogos/Bitbucket-blue.svg'
          },
          'recommendedProducts': [ 'jira', 'bamboo', 'jira-software' ],
          'moreLink': 'https://www.atlassian.com/software/bitbucket/overview',
          'onDemand': {
              'available': true,
              'url' : 'https://www.bitbucket.org/plans?utm_source=WAC&utm_medium=Button&utm_content=purchase_form&utm_campaign=BB',
              'key': 'bitbucket.ondemand',
              'crossSell': null
          },
          'url': 'product/bitbucket',
          'productName': 'Bitbucket',
          'productGroup': 'stash',
          'editionName': 'server'
      },
      'stash-data-center': {
          'productLongDescription': {
              'default': 'Collaborate on code with inline comments and pull requests. Manage and share your Git repositories. Build and ship as a team.'
          },
          'productTagLine': {
              'default': 'Git-based code collaboration and management'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Bitbucket-blue.svg',
              'xx':  '/sc-shared/img/productLogos/Bitbucket-blue.svg'
          },
          'moreLink': 'https://www.atlassian.com/software/bitbucket/overview',
          'onDemand': {
              'available': true,
              'url' : 'https://www.bitbucket.org/plans?utm_source=WAC&utm_medium=Button&utm_content=purchase_form&utm_campaign=BB',
              'key': 'bitbucket.ondemand',
              'crossSell': null
          },
          'url': 'product/stash-data-center',
          'productName': 'Bitbucket Data Center',
          'productGroup': 'stash',
          'editionName': 'dataCenter'
      },
      /** When Bitbucket rebranding is on, stash data will mainly be used for displaying info in shopping cart
       * Note that the product key is stash, so where we want to access data from productConstants for bitbucket server we should be using the
       * stash product key. This is also the product key if we want to access Bitbucket Server data from Hams/Hamlet.
       * TODO remove all properties except productKey in PUR-4703
       */
      'bitbucket': {
          'productLongDescription': {
              'default': 'Collaborate on code with inline comments and pull requests. Manage and share your Git repositories. Build and ship as a team.'
          },
          'productTagLine': {
              'default': 'Git-based code collaboration and management'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Bitbucket-blue.svg',
              'xx': '/sc-shared/img/productLogos/Bitbucket-blue.svg'
          },
          'recommendedProducts': [ 'jira', 'bamboo', 'jira-software' ],
          'moreLink': 'https://www.atlassian.com/software/bitbucket/overview',
          'onDemand': {
              'available': true,
              'key': 'bitbucket.ondemand'
          },
          'url': 'product/bitbucket',
          'productName': 'Bitbucket',
          'productKey' : 'stash'
      },
      // similar to bitbucket, this exists to get the product config page to display stash-data-center info while the url says bitbucket-data-center
      'bitbucket-data-center': {
          'productKey' : 'stash-data-center'
      },
      'fisheye': {
          'productLongDescription': {
            'default': 'Search, monitor, and track your Subversion repositories.'
          },
          'productTagLine': {
              'default': 'Browse & search code'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Fisheye-blue.svg',
              'xx': '/sc-shared/img/productLogos/Fisheye-blue.svg'
          },
          'recommendedProducts': [ 'crucible' ],
          'moreLink': 'https://www.atlassian.com/software/fisheye/overview',
          'onDemand': {
              'available': false,
              'key': null,
              'crossSell': null
          },
          'url': 'product/fisheye',
          'productName': 'Fisheye',
          'productGroup': 'fisheye',
          'editionName': 'server'
      },
      'crucible': {
          'productLongDescription': {
            'default': 'Find bugs and improve code quality through peer code review.'
          },
          'productTagLine': {
              'default': 'Peer code review'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Crucible-blue.svg',
              'xx': '/sc-shared/img/productLogos/Crucible-blue.svg'
          },
          'recommendedProducts': [ 'fisheye' ],
          'moreLink': 'https://www.atlassian.com/software/crucible/overview',
          'onDemand': {
              'available': false,
              'key': null,
              'crossSell': null
          },
          'url': 'product/crucible',
          'productName': 'Crucible',
          'productGroup': 'crucible',
          'editionName': 'server'
      },
      'bamboo': {
          'productLongDescription': {
            'default': 'Continuous integration, deployment, and release management.'
          },
          'productTagLine': {
              'default': 'Continuous integration'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Bamboo-blue.svg',
              'xx': '/sc-shared/img/productLogos/Bamboo-blue.svg'
          },
          'moreLink': 'https://www.atlassian.com/software/bamboo/overview',
          'onDemand': {
              'available': false,
              'key': null
          },
          'url': 'product/bamboo',
          'productName': 'Bamboo',
          'productGroup': 'bamboo',
          'editionName': 'server'
      },
      'crowd': {
          'productLongDescription': {
            'default': 'Identity management for your users, web apps, and directory servers.'
          },
          'productTagLine': {
              'default': 'Identity management'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Crowd-blue.svg',
              'xx': '/sc-shared/img/productLogos/Crowd-blue.svg'
          },
          'moreLink': 'https://www.atlassian.com/software/crowd/overview',
          'onDemand': {
              'available': false,
              'key': null
          },
          'url': 'product/crowd',
          'productName': 'Crowd',
          'productGroup': 'crowd',
          'editionName': 'server'
      },
      'atlassian.university.confluence': {
          'productLongDescription': null,
          'productTagLine': null,
          'images': {
              'xxx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg',
              'xx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg'
          },
          'productName': 'Atlassian University for Confluence'
      },
      'atlassian.university.jira': {
          'productLongDescription': null,
          'productTagLine': null,
          'images': {
              'xxx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg',
              'xx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg'
          },
          'productName': 'Atlassian University for Jira'
      },
      'atlassian.university.greenhopper': {
          'productLongDescription': null,
          'productTagLine': null,
          'images': {
              'xxx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg',
              'xx': '/sc-shared/img/productLogos/Atlassian_University-blue-rgb.svg'
          },
          'productName': 'Atlassian University for Jira Agile'
      },
      'jira.ondemand': {
          'productLongDescription':{
              'default': 'Enable development and IT teams to capture issues, plan work, and resolve requests. Spend less time managing work and more time building great software.'
          },
          'productTagLine':{
              'default': 'Plan, track, work'
          },
          'images':{
              'xxx': '/sc-shared/img/productLogos/Jira-blue.svg',
              'xx':'/sc-shared/img/productLogos/Jira-blue.svg'
          },
          'listOrder': 0,
          'moreLink':'http://www.atlassian.com/en/software/jira'
      },
      'greenhopper.jira.ondemand': {
          'productLongDescription':{
              'default': 'Agile project management for scrum or kanban teams.'
          },
           'productTagLine':{
              'default': 'Agile project management'
          },
           'images':{
              'xxx': '/sc-shared/img/productLogos/jiraagile_blue_xxxsmall.png',
              'xx':'/sc-shared/img/productLogos/jiraagile_blue_xxsmall.png'
           },
           'listOrder': 10,
           'moreLink':'http://www.atlassian.com/en/software/jira/agile'
      },
      'com.atlassian.servicedesk.ondemand': {
          'productLongDescription':{
              'default': 'Deliver an effortless service experience with powerful ticket management, an intuitive self-service portal, advanced SLAs and real-time reporting.'
          },
           'productTagLine':{
              'default': 'Service and support'
          },
          'images':{
              'xxx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg'
          },
          'listOrder': 20,
          'moreLink':'http://www.atlassian.com/en/software/jira/service-desk'
      },
      'com.radiantminds.roadmaps-jira.ondemand': {
          'productLongDescription': {
              'default': 'Know when you can deliver, react to change and keep everyone on the same page.'
          },
          'productTagLine': {
              'default': 'Project portfolio management'
          },
          'images': {
              'xxx': null,
              'xx': null
          },
          'listOrder': 30,
          'moreLink': 'https://marketplace.atlassian.com/plugins/com.radiantminds.roadmaps-jira',
          'productGroup': 'com.radiantminds.roadmaps-jira',
          'editionName': 'cloud'
      },
      'bonfire.jira.ondemand': {
          'productLongDescription':{
              'default': 'Rapid bug reporting for exploratory and session-based testing.'
          },
           'productTagLine':{
              'default': 'Exploratory testing'
          },
           'images':{
              'xxx': null,
              'xx': null
           },
           'listOrder': 40,
           'moreLink':'http://www.atlassian.com/en/software/jira-capture/overview',
          'productGroup': 'com.atlassian.bonfire.plugin',
          'editionName': 'cloud'
      },
      'com.atlassian.bitbucket': {
          'productLongDescription':{
              'default': 'Your code, in the cloud. Manage, review, and share your Git and Mercurial source code with free unlimited private repositories.'
          },
           'productTagLine':{
              'default': 'Git & Mercurial code hosting'
          },
          'images':{
             'xxx': '/sc-shared/img/productLogos/Bitbucket-blue.svg',
             'xx':'/sc-shared/img/productLogos/Bitbucket-blue.svg'
          },
          'listOrder': 60,
          'moreLink':'https://www.atlassian.com/en/software/bitbucket/overview',
          'productGroup': 'stash',
          'editionName': 'cloud'
      },
      'confluence.ondemand': {
          'productLongDescription':{
              'default': 'Give your team one place to share, find, and collaborate on information they need to get work done.'
          },
           'productTagLine':{
              'default': 'Create & collaborate'
          },
          'images':{
             'xxx': '/sc-shared/img/productLogos/Confluence-blue.svg',
             'xx':'/sc-shared/img/productLogos/Confluence-blue.svg'
          },
          'listOrder': 0,
          'moreLink':'https://www.atlassian.com/en/software/confluence',
          'productGroup': 'confluence',
          'editionName': 'cloud',
          'instanceRedirectSuffix': '/wiki'
      },
      'com.atlassian.confluence.plugins.confluence-questions.ondemand': {
          'productLongDescription': {
            'default': 'Capture, learn from, and retain the collective knowledge of your organization as it grows.'
          },
          'productTagLine': {
              'default': 'Share knowledge'
          },
          'images': {
              'xxx': null,
              'xx': null
          },
          'listOrder': 10,
          'recommendedProducts': [],
          'moreLink': 'https://www.atlassian.com/en/software/confluence/questions',
          'productGroup': 'com.atlassian.confluence.plugins.confluence-questions',
          'editionName': 'cloud'
      },
      'team.calendars.confluence.ondemand': {
          'productLongDescription':{
              'default': 'Your team\'s single source of truth for managing team leave, tracking Jira projects, and planning events. Confluence Team Calendars connects Confluence and Jira like never before.'
          },
           'productTagLine':{
              'default': ' '
          },
           'images':{
              'xxx' : null,
              'xx' : null
           },
           'listOrder': 20,
           'moreLink':'http://www.atlassian.com/en/software/confluence/team-calendars',
          'productGroup': 'com.atlassian.confluence.extra.team-calendars',
          'editionName': 'cloud'
      },
      'com.atlassian.hipchat': {
          'productLongDescription': {
              'default': 'Hipchat is a hosted private chat service for your company and team. Share ideas and files in persistent group chat rooms, video chats, and more. Get a free month of Hipchat Plus with your Atlassian Cloud subscription.'
          },
          'productTagLine': {
              'default': 'Chat and share'
          },
          'images': {
              'xxx' : '/sc-shared/img/productLogos/Hipchat-blue.svg',
              'xx' : '/sc-shared/img/productLogos/Hipchat-blue.svg'
          },
          'marketplace': false,
          'listOrder': 10,
          'moreLink':'http://www.atlassian.com/en/software/hipchat',
          'url': 'https://www.hipchat.com/sign_up?utm_source=atlassian&utm_medium=wac-order-form&utm_campaign=hipchat-launch',
          'overrides': {
            monthly: [{
              editionType: "role-tier",
              editionTypeIsDeprecated: true,
              price: 0,
              unitBlockSize: 987654321,
              unitLabel: "USER",
              unitLimit: -1,
              unitStart: 1
            }]
          },
          'featured': true,
          'productGroup': 'com.atlassian.hipchat',
          'editionName': 'cloud'
      },
      'jira-software': {
          'productLongDescription': {
              'default': 'The #1 software development tool used by agile teams. Plan, track, and release world-class software.'
          },
          'productTagLine': {
              'default': 'Issue tracking and code integration'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Software-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Software-blue.svg'
          },
          'recommendedProducts': ['com.radiantminds.roadmaps-jira', 'jira-servicedesk', 'confluence', 'stash'],
          'onDemand': {
              'available': true,
              'key': 'jira-software.ondemand'
          },
          url: 'product/jira-software',
          'store': false,
          productName: 'Jira Software',
          'productGroup': 'jira-software',
          'editionName': 'server'
      },
      'jira-software.data-center': {
          'productLongDescription': {
              'default': 'The #1 software development tool used by agile teams. Plan, track, and release world-class software.'
          },
          'productTagLine': {
              'default': 'Issue tracking and code integration'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Software-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Software-blue.svg'
          },
          'onDemand': {
              'available': true,
              'key': 'jira-software.ondemand'
          },
          url: 'product/jira-software',
          'store': false,
          productName: 'Jira Software Data Center',
          'productGroup': 'jira-software',
          'editionName': 'dataCenter'
      },
      'jira-core': {
          'productLongDescription': {
              'default': 'Simplify projects, from marketing campaigns, HR onboarding, to purchasing approvals and legal document reviews.'
          },
          'productTagLine': {
              'default': 'Project management for business teams'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Core-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Core-blue.svg'
          },
          'onDemand': {
              'available': true,
              'key': 'jira-core.ondemand'
          },
          url: 'product/jira-core',
          store: false,
          productName: 'Jira Core',
          'productGroup': 'jira-core',
          'editionName': 'server'
      },
      'jira-servicedesk': {
          'productLongDescription': {
              'default': 'Give your customers an easy way to ask for help and your agents a fast way to resolve incidents.'
          },
          'productTagLine': {
              'default': 'IT support and self-service'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg'
          },
          'recommendedProducts': ['confluence'],
          'onDemand': {
              'available': true,
              'key': 'jira-servicedesk.ondemand'
          },
          'message': {
              'userTier': 'Choose your Jira Service Desk agent tier'
          },
          url: 'product/jira-servicedesk',
          store: false,
          productName: 'Jira Service Desk',
          'productGroup': 'jira-servicedesk',
          'editionName': 'server'
      },
      'jira-servicedesk.data-center': {
          'productLongDescription': {
              'default': 'Give your customers an easy way to ask for help and your agents a fast way to resolve incidents.'
          },
          'productTagLine': {
              'default': 'IT support and self-service'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg'
          },
          'onDemand': {
              'available': true,
              'key': 'jira-servicedesk.ondemand'
          },
          'message': {
              'userTier': 'Choose your Jira Service Desk agent tier'
          },
          url: 'product/jira-servicedesk',
          store: false,
          productName: 'Jira Service Desk Data Center',
          'productGroup': 'jira-servicedesk',
          'editionName': 'dataCenter'
      },
      'jira-software.ondemand': {
          'productLongDescription': {
              'default': 'The #1 software development tool used by agile teams. Plan, track, and release world-class software.'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Software-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Software-blue.svg'
          },
          'listOrder': 0,
          'moreLink': '/software/jira',
          'productGroup': 'jira-software',
          'editionName': 'cloud'
      },
      'jira-servicedesk.ondemand': {
          'productLongDescription': {
              'default': 'Give your customers an easy way to ask for help and your agents a fast way to resolve incidents.'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Service_Desk-blue.svg'
          },
          'listOrder': 1,
          'moreLink': '/software/jira/service-desk',
          'productGroup': 'jira-servicedesk',
          'editionName': 'cloud'
      },
      'jira-core.ondemand': {
          'productLongDescription': {
              'default': 'Simplify projects, from marketing campaigns, HR onboarding, to purchasing approvals and legal document reviews.'
          },
          'images': {
              'xxx': '/sc-shared/img/productLogos/Jira_Core-blue.svg',
              'xx': '/sc-shared/img/productLogos/Jira_Core-blue.svg'
          },
          'listOrder': 2,
          'moreLink': '/software/jira/core',
          'productGroup': 'jira-core',
          'editionName': 'cloud'
      },
      // Deprecated product left behind to support existing Hipchat (Server) accounts (renew/upgrade pages), and to support the old Hipchat url (to redirect)
      'com.atlassian.hipchat.server': {
          'productLongDescription': {
              'default': 'Hipchat is a hosted private chat service for your company and team. Share ideas and files in persistent group chat rooms, video chats, and more. Get your team off AIM, Google Talk, and Skype – Hipchat is built for business.'
          },
          'productTagLine': {
              'default': 'Chat and share'
          },
          'images': {
              'xxx' : '/sc-shared/img/productLogos/Hipchat-blue.svg',
              'xx' : '/sc-shared/img/productLogos/Hipchat-blue.svg'
          },
          'url': 'product/com.atlassian.hipchat.server',
          'productName': 'Hipchat',
          'editionName': 'server'
      }
    };
  }

  updateProductDescriptions() {
    // stubbed
  }

}
